import { type Product } from "@/graphql/codegen/graphql"

export const isMatchingLocationAssociation = ({
  product,
  rowSelectionState,
  products,
}: {
  product: Product
  rowSelectionState: Record<string, boolean>
  products: Product[]
}): boolean => {
  const rowLocationId = product.locationsAssociations[0]?.locationAssociationId

  if (!rowLocationId || !products.length) return true

  const selectedLocationIds = products
    .filter((product) => rowSelectionState[product.productId.toString()])
    .map((product) => product.locationsAssociations[0]?.locationAssociationId)
    .filter((id): id is string => Boolean(id && id.length))

  if (selectedLocationIds.length === 0) return true

  return selectedLocationIds.every((id) => id === rowLocationId)
}
